import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  activePageUnderlined: {
    borderBottom: '2px solid',
    borderBottomColor: theme.palette.secondary.main,
  },
  containerContainer: {
    height: '100%',
    flexDirection: 'column',
    paddingBottom: '24px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  mainBoxContainer: {
    display: 'flex',
    width: '100%',
    paddingTop: '10px',
    gap: '24px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  deleteDeviceButton: {
    maxWidth: '200px',
    margin: '16px 0px 16px auto',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  box: {
    flex: 1,
  },
  divider: {
    margin: '5px 0px',
    width: '100%',
  },
  imagesDivider: {
    marginBottom: theme.spacing(2),
    backgroundColor: 'rgba(170, 170, 170, 1)',
  },

  // devicesInfoComponent
  cardLayoutContainer: {
    display: 'flex',
    flex: '1',
    boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.1)',
  },
  cardLayoutContentContainer: {
    width: '100%',
  },
  boxContentContainer: {
    flexDirection: 'column',
    gap: '10px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  infoCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  infoRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: theme.spacing(4),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  infoItem: {
    width: '100%',
  },
  tableCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  imagesCard: {
    padding: theme.spacing(2),
  },
  statusBadge: {
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    marginLeft: theme.spacing(1),
  },
  operativeStatus: {
    backgroundColor: '#E8F5E9',
    color: '#4CAF50',
  },
  offlineStatus: {
    backgroundColor: '#FFEBEE',
    color: '#F44336',
  },
  repairStatus: {
    backgroundColor: '#FFF3E0',
    color: '#FF9800',
  },
  tableHeader: {
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
  },

  // imagesComponent
  cardImagesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  cardImagesContentContainer: {
    width: '100%',
    textAlign: 'center',
  },
  imagesHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  },
  imageMainContainer: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  mainImage: {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: theme.shape.borderRadius,
  },
  navButtonLeft: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    left: theme.spacing(2),
  },
  navButtonRight: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    right: theme.spacing(2),
  },
  deleteButton: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  addImageButton: {
    cursor: 'pointer',
  },
  thumbnailContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  thumbnail: {
    width: 70,
    height: 70,
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
  },
  activeThumbnail: {
    border: '4px solid rgba(54, 147, 213, 1)',
  },

}));

export default useStyles;
